document.addEventListener('DOMContentLoaded', function() {
  const contentDiv = document.getElementById('articleContent');
  const tocList = document.getElementById('tocList');
  
  if (!contentDiv || !tocList) return;

  const headings = contentDiv.querySelectorAll('h2');
  if (headings.length === 0) {
    // 如果没有 H2，隐藏左侧目录区域
    const nav = document.querySelector('.article-nav');
    if (nav) nav.style.display = 'none';
    return;
  }

  // 为每个 H2 生成 ID（用于锚点）
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let slug = heading.textContent.trim()
        .toLowerCase()
        .replace(/[^\w\u4e00-\u9fa5]+/g, '-')
        .replace(/--+/g, '-')
        .replace(/^-|-$/g, '');
      if (!slug) slug = `section-${index}`;
      heading.id = slug;
    }
    
    // 添加到目录列表
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent;
    a.setAttribute('data-id', heading.id);
    
    a.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.getElementById(this.getAttribute('data-id'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, null, `#${this.getAttribute('data-id')}`);
      }
    });
    
    li.appendChild(a);
    tocList.appendChild(li);
  });
  
  // 滚动高亮当前章节
  const navLinks = document.querySelectorAll('#tocList a');
  function updateActiveNav() {
    let currentActive = '';
    const scrollPosition = window.scrollY + 100;
    
    for (let i = 0; i < headings.length; i++) {
      const heading = headings[i];
      const offsetTop = heading.offsetTop;
      const offsetBottom = offsetTop + heading.offsetHeight;
      if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
        currentActive = heading.id;
        break;
      }
    }
    
    navLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('data-id') === currentActive) {
        link.classList.add('active');
      }
    });
  }
  
  window.addEventListener('scroll', updateActiveNav);
  window.addEventListener('resize', updateActiveNav);
  updateActiveNav();
});